import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ScoreboardWidgetScoreCellViewModel} from "../models/scoreboard-widget.score-cell-view-model";
import {TableCell} from "../../../core/components/table/table-cell";
import {ScoreboardCell} from "../../../core/components/misc/scoreboard-cell/scoreboard-cell";

export class ScoreboardWidgetScoreCellProps extends BaseProps {
  cell: ScoreboardWidgetScoreCellViewModel;
}

export const ScoreboardWidgetScoreCell = (props: ScoreboardWidgetScoreCellProps) => {
  const scoreProps = {
    isMainScore: props.cell.isMainScore,
    isWinner: props.cell.isWinner,
    isLive: props.cell.isLive,
    score: props.cell.score,
    extraScore: props.cell.extraScore
  }

  return (
    <TableCell className={'scoreboard-widget-score-cell'}>
      <ScoreboardCell {...scoreProps}/>
    </TableCell>
  )
};
